import script from "./ReadOnlyBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./ReadOnlyBanner.vue?vue&type=script&setup=true&lang=js"

import "./ReadOnlyBanner.vue?vue&type=style&index=0&id=1924d8b6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1924d8b6"]])

export default __exports__